module.exports = "/_next/static/images/3be40f8b44e04ba1ce829b193ceba380-notaxes@0.5x.jpg";